import { render } from "./AddContactToClient.vue?vue&type=template&id=25e1a7cd"
import script from "./AddContactToClient.vue?vue&type=script&lang=js"
export * from "./AddContactToClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__